import { render, staticRenderFns } from "./item-bundle.vue?vue&type=template&id=7709de09&"
import script from "./item-bundle.vue?vue&type=script&lang=js&"
export * from "./item-bundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports